/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.cutin", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console", {value: "call DisplayComponent/show.cutin"});
            args.tweener
            .call(function(_args){
                _args.scene.addChild(BattleScene.Cutin({
                    motion: _args.motion,
                    src: _args.src,
                }).setPosition(0, 0));
            }, null, [args])
            .wait(1000);
        }
    });

    April.define("DisplayComponent/show.change-icon", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var ch = args.scene.member[args.player];
            ch.iconImage.setImage(args.src).setSize(300,75)
            .setScale(args.revSide ? ch.reverse : 1,1);
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value: "call DisplayComponent/show.change-icon"});
            args.tweener
            .call(function(_args){
                ch.iconImage.setImage(_args.src).setSize(300,75)
                .setScale(_args.revSide ? ch.reverse : 1,1);
            }, null, [args]);
        }
    });

    April.define("DisplayComponent/show.reset-icon", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var ch = args.scene.member[args.player];
            ch.iconImage.setImage(ch.icon).setSize(300,75)
            .setScale(ch.iconR ?ch.reverse :1,1);
        }else if(args.opr == 'back'){
            var ch = args.scene.member[args.player];
            ch.iconImage.setImage(ch.icon).setSize(300,75)
            .setScale(ch.iconR ?ch.reverse :1,1);
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value: "call DisplayComponent/show.reset-icon"});
            args.tweener
            .call(function(_args){
                ch.iconImage.setImage(ch.icon).setSize(300,75)
                .setScale(ch.iconR ?ch.reverse :1,1);
            }, null, [args]);
        }
    });

    April.define("log.remark", function(args){
      if(args.opr == 'split'){
          return false;
      }else if(args.opr == 'next'){
      }else if(args.opr == 'back'){
      }else if(args.opr == 'play'){
          var scene=args.scene;
          var ch = args.scene.member[args.player];
          scene.flare("act_console", {value:"call log.remark"});
          var text = (args.text||'')
            .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
            .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
          args.tweener
          .call(function(_args){
            var f=BattleScene.Remark({
              width:300, height:50, padding:30,
              text:text, fontSize:20,
              stroke:'#2e2614', fill:'#FFF', strokeWidth: 10,
              arrowRadian: phina.geom.Vector2(-200*ch.reverse,50).toAngle(),
            }).addChildTo(ch)
            .setPosition(150*ch.reverse,0).setScale(0,0);
            f.tweener
              .by({
                x:f.width/2*ch.reverse, y:-25,
                scaleX:1.0, scaleY:1.0,
              },200,"easeOutCubic")
              .wait(_args.time?_args.time-200:800)
              .call(function(){ f.remove(); }.bind(this));
          }, null, [args])
          .wait(args.delay)
      }
    });    
}
